import { format } from "date-fns";
import { useState } from "react";
import { useAnalyses } from "@/hooks/useAnalyses";
import { AnalysisService } from "@/services/analysis/analysis.service";
import { showError, showSuccess } from "@/utils/notification";
import { useWorkspaces } from "./useWorkspaces";

export const useExecuteAnalysis = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const { mutate: mutateAnalyses } = useAnalyses();

  const executeAnalysis = async (
    title: string,
    startDate: Date,
    endDate: Date,
    categoryTreeId: string,
    period?: Date,
    isPeriodicAnalysis: boolean = false,
  ) => {
    setIsLoading(true);

    const start_date = format(startDate, "yyyy-MM-dd");
    const end_date = format(endDate, "yyyy-MM-dd");
    const period_str = period && isPeriodicAnalysis ? format(period, "yyyy-MM") : undefined;

    try {
      await AnalysisService.executeAnalysis(
        sessionCurrentWorkspaceId,
        title,
        start_date,
        end_date,
        categoryTreeId,
        period_str,
      );
      setIsLoading(false);
      showSuccess("分析を実行しました。");

      // 分析一覧を再取得
      await mutateAnalyses();
    } catch (error) {
      console.error(error);
      showError("分析の実行に失敗しました。");
    }
  };

  return {
    isLoading,
    executeAnalysis,
  };
};
